import classNames from 'classnames';
import { ReactComponent as RightArrow } from 'assets/right-arrow.svg';
import { ReactComponent as LeftArrow } from 'assets/leftArrow.svg';
import { ReactComponent as DropdownArrow } from 'assets/dropdown-arrow.svg';
import { ReactComponent as EmailIcon } from 'assets/email-icon.svg';
import { ReactComponent as PasswordIcon } from 'assets/password-icon.svg';
import { ReactComponent as CloseIcon } from 'assets/close-icon.svg';
import { ReactComponent as UserIcon } from 'assets/user-icon.svg';
import { ReactComponent as SearchIcon } from 'assets/search-icon.svg';
import { ReactComponent as DownloadIcon } from 'assets/download-icon.svg';
import { ReactComponent as HouseIcon } from 'assets/house-icon.svg';
import { ReactComponent as ClipboardIcon } from 'assets/clipboard-icon.svg';
import { ReactComponent as ClockIcon } from 'assets/clock-icon.svg';
import { ReactComponent as TrashIcon } from 'assets/trash-icon.svg';
import { ReactComponent as EditIcon } from 'assets/edit-icon.svg';
import { ReactComponent as EditIcon2 } from 'assets/edit-icon2.svg';
import { ReactComponent as CheckmarkCircle } from 'assets/checkmark-circle-outline.svg';
import { ReactComponent as CopyIcon } from 'assets/copy-icon.svg';
import { ReactComponent as VideoIcon } from 'assets/video-icon.svg';
import { ReactComponent as PlusIcon } from 'assets/plus-icon.svg';
import { ReactComponent as CalendarIcon } from 'assets/calendar-icon.svg';
import { ReactComponent as ReadingTabIcon } from 'assets/reading_tab_icon.svg';
import { ReactComponent as WritingTabIcon } from 'assets/writing_tab_icon.svg';
import { ReactComponent as ListeningTabIcon } from 'assets/listening_tab_icon.svg';
import { ReactComponent as GrammerTabIcon } from 'assets/grammer_tab_icon.svg';
import { ReactComponent as TimerIcon } from 'assets/timer_icon.svg';
import { ReactComponent as StarIcon } from 'assets/star.svg';
import { ReactComponent as AvatarIcon } from 'assets/avatar-icon.svg';
import { ReactComponent as SelectedAvatarIcon } from 'assets/selected-avatar-icon.svg';
import { ReactComponent as AttachIcon } from 'assets/attach_icon.svg';
import { ReactComponent as ChatSendIcon } from 'assets/chat_send_icon.svg';
import { ReactComponent as WordIcon } from 'assets/word-icon.svg';
import { ReactComponent as PdfIcon } from 'assets/pdf-icon.svg';
import { ReactComponent as LockIcon } from 'assets/lock-Icon.svg';
import { ReactComponent as PngIcon } from 'assets/png-icon.svg';
import { ReactComponent as JpgIcon } from 'assets/jpg-icon.svg';
import { ReactComponent as SeenMessageIcon } from 'assets/seen-message-icon.svg';
import { ReactComponent as SentMessageIcon } from 'assets/sent-message-icon.svg';
import { ReactComponent as DownloadIconV2 } from 'assets/download-icon-v2.svg';
import { ReactComponent as EyeIcon } from 'assets/eye-icon.svg';
import { ReactComponent as PhoneIcon } from 'assets/phone-icon.svg';
import { ReactComponent as WhatsAppIcon } from 'assets/whatsApp-Icon.svg';
import { ReactComponent as ReviewIcon } from 'assets/leave-review-icon.svg';
import { ReactComponent as ContactIcon } from 'assets/contact-icon.svg';
import { ReactComponent as ContactIconV2 } from 'assets/contact-icon_v2.svg';
import { ReactComponent as CertificateIcon } from 'assets/certificate-icon.svg';
import { ReactComponent as CopyClipboard } from 'assets/copy-to-clipboard-icon.svg';
import { ReactComponent as ReplayIcon } from 'assets/replay-icon.svg';
import { ReactComponent as ApprovalIcon } from 'assets/chat-approve-icon.svg';
import { ReactComponent as DoneIcon } from 'assets/changes_spiner_done.svg';
import { ReactComponent as MinusIcon } from 'assets/minus-icon.svg';
import { ReactComponent as RemoveIcon } from 'assets/remove-icon.svg';
import { ReactComponent as AddIcon } from 'assets/add-icon.svg';
import { ReactComponent as GlobalIcon } from 'assets/global.svg';
import { ReactComponent as SaveIcon } from 'assets/save-icon.svg';
import { ReactComponent as SuccessVicon } from 'assets/success-v-icon.svg';

const Icon = ({ icon, size = 15, color, onClick, onTouchStart, extraClassName }) => {
	const className = classNames('Icon', {
		[extraClassName]: extraClassName,
	});

	const _handleOnClick = e => {
		if (onClick && typeof onClick === 'function') onClick(e);
	};
	const _handleOnTouchStart = e => {
		if (onTouchStart && typeof onTouchStart === 'function') onTouchStart(e);
	};

	const iconsList = {
		rightArrow: <RightArrow width={size} height={size} fill={color} />,
		leftArrow: <LeftArrow width={size} height={size} fill={color} />,
		dropdownArrow: <DropdownArrow width={size} height={size} fill={color} />,
		emailIcon: <EmailIcon width={size} height={size} fill={color} />,
		passwordIcon: <PasswordIcon width={size} height={size} fill={color} />,
		closeIcon: <CloseIcon width={size} height={size} fill={color} />,
		userIcon: <UserIcon width={size} height={size} fill={color} />,
		searchIcon: <SearchIcon width={size} height={size} fill={color} />,
		downloadIcon: <DownloadIcon width={size} height={size} fill={color} />,
		downloadIconV2: <DownloadIconV2 width={size} height={size} fill={color} />,
		houseIcon: <HouseIcon width={size} height={size} fill={color} />,
		clipboardIcon: <ClipboardIcon width={size} height={size} fill={color} />,
		clockIcon: <ClockIcon width={size} height={size} fill={color} />,
		trashIcon: <TrashIcon width={size} height={size} fill={color} />,
		editIcon: <EditIcon width={size} height={size} fill={color} />,
		editIcon2: <EditIcon2 width={size} height={size} fill={color} />,
		checkmark: <CheckmarkCircle width={size} height={size} fill={color} />,
		copyIcon: <CopyIcon width={size} height={size} fill={color} />,
		videoIcon: <VideoIcon width={size} height={size} fill={color} />,
		plusIcon: <PlusIcon width={size} height={size} fill={color} />,
		calendarIcon: <CalendarIcon width={size} height={size} fill={color} />,
		readingTabIcon: <ReadingTabIcon width={size} height={size} fill={color} />,
		writingTabIcon: <WritingTabIcon width={size} height={size} fill={color} />,
		listeningTabIcon: <ListeningTabIcon width={size} height={size} fill={color} />,
		grammerTabIcon: <GrammerTabIcon width={size} height={size} fill={color} />,
		timerIcon: <TimerIcon width={size} height={size} fill={color} />,
		starIcon: <StarIcon width={size} height={size} fill={color} />,
		avatarIcon: <AvatarIcon width={size} height={size} fill={color} />,
		selectedAvatarIcon: <SelectedAvatarIcon width={size} height={size} fill={color} />,
		attachIcon: <AttachIcon width={size} height={size} fill={color} />,
		chatSendIcon: <ChatSendIcon width={size} height={size} fill={color} />,
		wordIcon: <WordIcon width={size} height={size} fill={color} />,
		pdfIcon: <PdfIcon width={size} height={size} fill={color} />,
		lockIcon: <LockIcon width={size} height={size} fill={color} />,
		pngIcon: <PngIcon width={size} height={size} fill={color} />,
		jpgIcon: <JpgIcon width={size} height={size} fill={color} />,
		jpegIcon: <JpgIcon width={size} height={size} fill={color} />,
		seenMessageIcon: <SeenMessageIcon width={size} height={size} fill={color} />,
		sentMessageIcon: <SentMessageIcon width={size} height={size} fill={color} />,
		eyeIcon: <EyeIcon width={size} height={size} fill={color} />,
		phoneIcon: <PhoneIcon width={size} height={size} fill={color} />,
		whatsAppIcon: <WhatsAppIcon width={size} height={size} fill={color} />,
		reviewIcon: <ReviewIcon width={size} height={size} fill={color} />,
		contactIcon: <ContactIcon width={size} height={size} fill={color} />,
		ContactIconV2: <ContactIconV2 width={size} height={size} fill={color} />,
		certificateIcon: <CertificateIcon width={size} height={size} fill={color} />,
		copyClipboardIcon: <CopyClipboard width={size} height={size} fill={color} />,
		replayIcon: <ReplayIcon width={size} height={size} fill={color} />,
		approvalIcon: <ApprovalIcon width={size} height={size} stroke={color} />,
		doneIcon: <DoneIcon width={size} height={size} stroke={color} />,
		minusIcon: <MinusIcon width={size} height={size} stroke={color} />,
		removeIcon: <RemoveIcon width={size} height={size} stroke={color} />,
		addIcon: <AddIcon width={size} height={size} stroke={color} />,
		globalIcon: <GlobalIcon width={size} height={size} stroke={color} />,
		saveIcon: <SaveIcon width={size} height={size} stroke={color} />,
		successVicon: <SuccessVicon width={size} height={size} stroke={color} />,
	};

	if (icon in iconsList)
		return (
			<span className={className} onClick={_handleOnClick} onTouchStart={_handleOnTouchStart}>
				{iconsList[icon]}
			</span>
		);
	return null;
};

export default Icon;
